export const MOBILE_MAX_WIDTH = 760;
export const MOBILE_MEDIA_QUERY = "(max-width: 760px)";
export const PHONE_COLLECTION_SEARCH_QUERY = "(max-width: 600px)";
export const TOUCH_COLLECTION_MEDIA_QUERY = "(max-width: 1024px), (pointer: coarse)";
